import { FC } from 'react';
import { ModalColor } from '~shared/types/modal';
import cn from 'classnames';
import colorScheme from './colors';

interface IButtonProps {
  color?: ModalColor;
  variant?: 'solid' | 'outlined';
  onClick?: () => void;
  autoFocus?: boolean;
}

const Button: FC<IButtonProps> = ({
  color = ModalColor.PRIMARY,
  variant = 'solid',
  children,
  autoFocus,
  ...rest
}) => {
  const buttonColor = colorScheme[color].button;
  const buttonClasses =
    variant === 'outlined'
      ? `bg-transparent text-white border border-white hover:border-white hover:bg-white hover:text-${buttonColor}`
      : `text-white bg-${buttonColor} border border-${buttonColor} hover:border-white hover:bg-primary-hover hover:text-white`;

  return (
    <button
      autoFocus={autoFocus}
      className={cn(
        'w-16 rounded px-2 py-1 text-xs font-medium hover:font-bold focus:outline-none',
        buttonClasses,
      )}
      {...rest}
    >
      {children}
    </button>
  );
};

export default Button;
